import resource from '../../resources/resource'
import parse from '../../resources/parse'
import { map } from 'lodash'
import { get as find, set } from '@/helpers/sessionStorage'

const resetSearchedBy = (commit, getters) => {
  if (getters.searchedBy.length > 0) {
    set('patient-agenda-searchedBy', getters.searchedBy)

    return getters.searchedBy
  }

  commit('setValuesSearchedBy', find('patient-agenda-searchedBy'))
}

const getFilters = getters => {
  if (getters.filtersToSearchIsEmpty) {
    return find('patient-agenda-search')
  }

  set('patient-agenda-search', getters.filtersToSearch)

  return getters.filtersToSearch
}

export const loadAgendas = ({ commit, getters }) => {
  resetSearchedBy(commit, getters)

  resource.get('', getFilters(getters))
    .then(({data, meta}) => {
      commit('setLoading', false)
      commit('setAgendas', map(data, parse))
      commit('setPagination', meta.pagination)
    })
    .catch(() => {
      commit('setLoading', false)
    })
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/store/actions/agendas.js